import { useTranslation } from "react-i18next";
import styles from "./categories-skin-5.module.css";
import { useCategories } from "../../categories.hook";
import WidgetContainer from "../../../widget-container";
import { FC } from "react";

type CategoriesSkin5Props = {
  fullWidth?: boolean;
};

const CategoriesSkin5: FC<CategoriesSkin5Props> = ({ fullWidth }) => {
  const { t } = useTranslation();
  const { categories } = useCategories(5);

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      fullWidth={!!fullWidth}
      withoutPadding>

      <div className={styles.categoriesSkin5Container}>
        {categories?.map((category: any, index: number) =>
        <div
          key={`key-${index}`}
          className={`${styles.category} ${
          category.className.includes("view-more") ?
          `${styles.viewMore}` :
          ""
          }`}
          onClick={category.onClick}>

            {!category.className.includes("view-more") ?
          <img
            loading={"lazy"}
            className={styles.categoryImage}
            src={category.image}
            alt={category.name} /> :


          <img
            loading={"lazy"}
            className={styles.categoryImage}
            src={categories[index - 1]?.image}
            alt={categories[index - 1]?.name} />}


            <div className={styles.overlayer}></div>
            <div className={styles.categoryData}>
              {!category.className.includes("view-more") ?
            <>
                  <h3 className={styles.categoryName}>{category.name}</h3>
                  <span className={styles.categoryButton}>
                    {t("button.payment")}
                  </span>
                </> :

            <span className={styles.categoryButton}>{category.name}</span>}

            </div>
          </div>
        )}
      </div>
    </WidgetContainer>);

};

export default CategoriesSkin5;